import React from 'react';
import { useLocation } from 'react-router-dom';
import './BrandHeader.css';

const LOGOS = {
    default: {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/brand/arta-logo.png',
        alt: 'Arta Mobile',
    },
    mga: {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/mga.png',
        alt: 'MGA Partner',
    },
    rpi: {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/ruangpelaut.png',
        alt: 'MGA Partner',
    },
    asadromy: {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/asadromy.png',
        alt: 'Asad Romy',
    },
    satoeataptour : {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/satoeataptour.png',
        alt: 'Satoe Atap Tour',
    },
    jayrahmat : {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/jayrahmat.png',
        alt: 'Jay Rahmat',
    },
    influencermengaji : {
        src: 'https://d1qsbuaxtzmcn4.cloudfront.net/partner/influencermengaji.jpeg',
        alt: 'Influencer Mengaji',
    },
};

const BrandHeader = () => {
    const { search } = useLocation();
    const partner = new URLSearchParams(search).get('partner') || 'default';
    const { src, alt } = LOGOS[partner] || LOGOS.default;

    return (
        <header className="brand-header" role="banner">
            {/* fixed box prevents layout jump while image loads */}
            <img
                className="brand-logo"
                src={src}
                alt={alt}
                decoding="async"
                fetchpriority="high"
                onError={(e) => { e.currentTarget.src = LOGOS.default.src; }}
            />
        </header>
    );
};

export default BrandHeader;
